import React from 'react';
import Loading from 'yoda-site-components/lib/components/Loading/Loading';
import MiniPDPInterstitialAsync from 'yoda-mini-pdp/lib/components/MiniPDPInterstitial/MiniPDPInterstitialAsync';

/* istanbul ignore next */
const renderMiniPDP = () => (
    <>
        <Loading />
        <MiniPDPInterstitialAsync />
    </>
);
export default renderMiniPDP;
